import React from 'react';
import {
  Box,
  Typography,
  Paper,
  Container,
  Chip
} from '@mui/material';
import { AdminPanelSettings } from '@mui/icons-material';

const UserManagement = () => {
  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Box textAlign="center" mb={4}>
        <AdminPanelSettings sx={{ fontSize: 60, color: 'primary.main', mb: 2 }} />
        <Typography variant="h3" component="h1" gutterBottom>
          User Management
        </Typography>
        <Typography variant="h5" color="text.secondary" gutterBottom>
          Comprehensive System User Administration
        </Typography>
        <Chip 
          label="Coming Soon" 
          color="primary" 
          variant="outlined" 
          sx={{ mt: 2 }}
        />
      </Box>

      <Paper elevation={3} sx={{ p: 4 }}>
        <Typography variant="h4" gutterBottom>
          Module Overview
        </Typography>
        <Typography variant="body1" paragraph>
          The User Management module will provide comprehensive administration capabilities for managing system users, 
          roles, permissions, and access control across all modules of the TKM Group MIS.
        </Typography>
        
        <Typography variant="h6" gutterBottom sx={{ mt: 3, mb: 2 }}>
          Key Features:
        </Typography>
        <ul>
          <li>Create and manage system users</li>
          <li>Assign roles and permissions</li>
          <li>Manage user access and security</li>
          <li>Track user activity and login history</li>
          <li>Generate user reports and analytics</li>
          <li>Password management and security</li>
          <li>User profile and preference management</li>
          <li>System audit trails and logging</li>
        </ul>
      </Paper>
    </Container>
  );
};

export default UserManagement; 